import { render, staticRenderFns } from "./SchoolDetailLite.vue?vue&type=template&id=96962304&scoped=true"
import script from "./SchoolDetailLite.vue?vue&type=script&lang=js"
export * from "./SchoolDetailLite.vue?vue&type=script&lang=js"
import style0 from "./SchoolDetailLite.vue?vue&type=style&index=0&id=96962304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96962304",
  null
  
)

export default component.exports